import React, { useState, useEffect, useRef } from "react";

import { useTranslation } from "react-i18next";
import CarouselCard from "./CarouselCard";

import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { carouselNumbers } from "../../utils/NumberDetails";
import {
  setDrawTab,
  setShouldSpinWheel,
  setSpinAgainTimeout,
} from "../../store/picks/tabs-slice";
import { clearAndSetCarouselNumber } from "../../store/picks/carousel-slice";
import store from "../../store/store";
import { clearWin, setCredit } from "../../store/config-slice";
import ModalMessage from "../Common/ModalMessage/ModalMessage";

import img0 from "../../assets/img/carousel/10-gold.svg";
import img1 from "../../assets/img/carousel/20-gold.svg";
import img2 from "../../assets/img/carousel/1000-gold.svg";
import img3 from "../../assets/img/carousel/50-gold.svg";
import img4 from "../../assets/img/carousel/100-gold.svg";
import AudioPlayerNonInteractiveEffect from "../Common/AudioPlayer/AudioEffect/AudioPlayerNonInteractiveEffect";
import { getAudio } from "../../utils/AudioUtils";
import { AudioEnum, GameTypeEnum } from "../../enums";

const Carousel: React.FC = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const numbersToAdd = [];
  const svgNumbers = [img0, img1, img2, img3, img4];
  const carouselNumber = useAppSelector(
    (state) => state.carousel.carouselNumberForSpin
  );
  const prevCarouselNumber = useAppSelector(
    (state) => state.carousel.prevCarouselNumber
  );
  const [winAmount, setWinAmount] = useState(-1);
  const spinningActive = useRef(false);

  useEffect(() => {
    let carouselTimeout: NodeJS.Timeout;
    if (spinningActive.current && carouselNumber > -1) {
      carouselTimeout = setTimeout(() => {
        spinningActive.current = false;
        if (store.getState().config.gameType === GameTypeEnum.ONLINE) {
          dispatch(setDrawTab(false));
        } else {
          dispatch(setShouldSpinWheel(false));
        }
        dispatch(clearAndSetCarouselNumber());
        setWinAmount(store.getState().config.winAmmount);
        dispatch(
          setCredit({
            balance:
              store.getState().config.balance +
              store.getState().config.winAmmount,
          })
        );
        dispatch(clearWin());
      }, 3000);
    }
    return () => clearTimeout(carouselTimeout);
  }, [carouselNumber, dispatch]);

  const arrayOffsetIndex =
    prevCarouselNumber === -1 ? 0 : (prevCarouselNumber + 3) % 5;

  const carouselNumbersSorted = [
    ...carouselNumbers.slice(-(5 - arrayOffsetIndex)),
    ...carouselNumbers.slice(0, arrayOffsetIndex),
  ];

  const svgNumbersSorted = [
    ...svgNumbers.slice(-(5 - arrayOffsetIndex)),
    ...svgNumbers.slice(0, arrayOffsetIndex),
  ];

  for (let i = 0; i < svgNumbers.length; i += 1) {
    numbersToAdd.push(
      <CarouselCard
        key={`numbersToAdd_${i}`}
        classPosition={i + 1}
        svgSource={svgNumbersSorted[i]}
      />
    );
  }

  const spinCount = carouselNumbersSorted.indexOf(
    carouselNumbers[carouselNumber]
  );

  if (carouselNumber > -1) {
    spinningActive.current = true;
  }

  return (
    <>
      <div
        className={`carousel ${carouselNumber > -1 ? `stop${spinCount}` : ""}`}
      >
        {numbersToAdd}
      </div>
      {spinningActive.current && (
        <AudioPlayerNonInteractiveEffect
          audioEffectToBePlayed={getAudio(AudioEnum.EFFECT_CAROUSEL)}
        />
      )}
      {winAmount > 0 && (
        <ModalMessage
          className="fade_modal"
          message={t("message.congratsWin")}
          onApprove={() => {
            setWinAmount(-1);
            dispatch(setSpinAgainTimeout(3));
          }}
          winAmount={winAmount}
        />
      )}
    </>
  );
};

export default React.memo(Carousel);
